var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center items-center min-h-screen"},[_c('p',[_vm._v("กำลังเข้าสู่ระบบผ่าน LINE...")])])
}]

export { render, staticRenderFns }